export function getQueryParams(searchTerm: string, searchType: string) {
    return {
        [searchType]: searchTerm
    };
}